import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "../../../environments/environment";
import Exercise from "../../models/exercise.model";

@Component({
  selector: "ngx-view-exercise-detail",
  styleUrls: ["./view-exercise-detail.component.scss"],
  templateUrl: "./view-exercise-detail.component.html",
})
export class ViewExerciseDetailComponent implements OnInit {
  @Input() exercise: Exercise;
  @Input() mode?: string; //detail / other / home
  @Output() onRedirect: EventEmitter<any> = new EventEmitter();

  defaultCover = environment.logoUrl;

  constructor(private router: Router) {}

  ngOnInit(): void {}

  onClick() {
    this.onRedirect.emit(true);
    this.router.navigateByUrl(`/exercise/${this.exercise.id}`);
  }

  tagSelected(tag) {
    console.log("tagSelected:", tag);
  }
}
